<template>
   <v-row>
     <v-dialog v-model="showDialog" scrollable max-width="600px">
       <v-skeleton-loader v-if="loading" type="article, actions"></v-skeleton-loader>
       <v-card v-if="!loading">
         <v-card-title style="padding: 10px 0 0 10px; height: 20px;">
           <v-col cols="12">
            <img 
						:src="getProfileAssetUrl(data.profilePicture)" 
						style="object-fit: cover; width: 70px; height: 80px; float: left;" />
             <!--- <span style="font-size: 20px;">{{ $t('wkt.admin.telework.message-window.window_title_new') }}</span> -->
             <span  style="font-size: 20px; margin: 65px;">{{ profileFullName() }}</span>
             <br>
             <span style="font-size: 14px; margin: 65px">{{ data.departmentName }}</span>
           </v-col>
         </v-card-title>
         <v-card-text style="padding-bottom: 0;">
           <v-container>
             <v-form ref="form">
               <v-row style="margin-top: 60px;">
                 <v-col cols="12">
                   <v-text-field v-model="data.title" :label="$t('wkt.admin.telework.message-window.message_title')" autocomplete="none" :rules="[validationRules.required]" max="400"></v-text-field>
                 </v-col>
                 <v-col cols="12">
                   <v-textarea v-model="data.body" :label="$t('wkt.admin.telework.message-window.message_content')" rows="3" autocomplete="none" :rules="[validationRules.required]" max="400"></v-textarea>
                 </v-col>
               </v-row>
             </v-form>
           </v-container>
         </v-card-text>
         <v-divider></v-divider>
         <v-card-actions>
           <v-spacer></v-spacer>
           <v-btn color="#185EA9" text @click="onSave()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.send').toUpperCase() }}</v-btn>
           <v-btn text @click="showDialog=false" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
         </v-card-actions>
       </v-card>
     </v-dialog>
   </v-row>
 </template>
 
 <script>
 import BaseModule from '../../common/BaseModule.js'
 import api from '../../../api/worktime'
 import gwt from '../../../api/gwt.js'
 
 export default {
   name: 'TeleworkDialog',
   mixins: [BaseModule],
   data() {
     return {
       showDialog: false,
       loading: false,
       data: {
         title: '',
         body: '',
       }
     }
   },
   methods: {
    // eslint-disable-next-line no-unused-vars
     open(action, payload) {
       this.showDialog = true;
       if (this.$refs.form) {
         this.$refs.form.resetValidation();
       }

       this.loading = true;
         api.getFullDailyWorkdayById(payload, res => {
            this.data = res;
            this.loading = false;
         }, error => {
            this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            this.loading = false;
         })


     },
     onSave() {
       if (!this.$refs.form.validate()) {
         return;
       }
       this.loading = true;

       const me = gwt.getSessionInformation().employee;
       const recipientId = this.data.employeeId;

       const data = {
         senderId: me.id,
         companyId: me.companyId,
         title: this.data.title,
         body: this.data.body,
         actionType: 0,
         type: 3,
         employees: recipientId.toString(),
         creationDate: new Date().getTime(),
         sticky: false,
         enabled: true
       };

       // Envía el mensaje directo
       api.sendMessage(data, 
         res => {
           this.loading = false;
           if (res) {
             this.$emit('refresh');
             this.showDialog = false;
           } else {
             this.$emit('show-alert',{ text: this.$t('wkt.admin.telework.message_sent'), color: 'success', timeout: 3000 });
             this.showDialog = false;
           }
         },
         error => {
           this.$log.error(error);
           this.loading = false;
           this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
         }
       );
     },
     profileFullName() {
			if (!this.data.firstname) {
				return '';
			}

			return `${this.data.firstname} ${this.data.lastname}`;
		}
   }
 }
 </script>
